var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBreadcrumbArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 16,
  viewBox: "0 0 10 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M505.01,307l-1.668,1.6h0l-6.672,6.408-1.667-1.6L501.674,307,495,300.591l1.667-1.6,6.672,6.408h0Z",
  transform: "translate(-495 -299)"
})));
export default SvgBreadcrumbArrow;